import { formatTZDate } from 'component-utilities/dates/dates';

export default function prettyPrintFormatter(pretty: string) {
  const dateRegex = /(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(\\.[0-9]+)?(Z)?/g;

  return pretty.replace(dateRegex, match => formatTZDate(new Date(match)));
}
